module.exports = __webpack_public_path__ + "img/56381647914069_.pic.2a3fd83c.jpg";